function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewssumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 30,
    viewBox: "0 0 132 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "81yfcfakwa"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5178",
    style: {
      fill: "#143d57"
    },
    d: "M0 0h132v19.391H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 5179",
    style: {
      fill: "none"
    },
    d: "M0 0h132v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9691"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95052",
    d: "M12.808 2.576v10.242l.2 4.5-.152.051-2.287-4.574L5.057 2.576H0v18.476h3.456V10.836l-.2-4.524.144-.051 2.287 4.575 5.515 10.216h5.057V2.576z",
    transform: "translate(0 3.186)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95053",
    d: "M108.327 2.576h-.991v18.476h13.495V18h-9.937v-5h8.946v-2.978h-8.946v-4.4h9.937V2.576h-12.5z",
    transform: "translate(-88.276 3.186)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95054",
    d: "m208.108 12.742-.889 4.829h-.1L206 12.742l-2.9-10.166h-3.685l-2.9 10.166-1.115 4.828h-.1l-.89-4.829-2.44-10.165h-3.634l4.676 18.476h4.32l2.618-8.387 1.245-4.9h.127l1.245 4.88 2.618 8.412h4.321l4.676-18.476h-3.634z",
    transform: "translate(-154.892 3.185)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9690"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 9689",
    transform: "translate(0 5.304)",
    style: {
      clipPath: "url(#81yfcfakwa)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95055",
    d: "M349.174 8.7a23.377 23.377 0 0 0-3.227-1.08 21.431 21.431 0 0 1-2.173-.648 3.555 3.555 0 0 1-1.283-.8 1.785 1.785 0 0 1-.508-1.322 1.515 1.515 0 0 1 .813-1.436 4.634 4.634 0 0 1 2.211-.445 5.658 5.658 0 0 1 1.931.267 1.841 1.841 0 0 1 1.042.94 4.194 4.194 0 0 1 .3 1.893l3.736-.432a4.9 4.9 0 0 0-1.817-4.32A8.319 8.319 0 0 0 345.26 0a9.758 9.758 0 0 0-3.507.585 5.14 5.14 0 0 0-2.4 1.8 5.047 5.047 0 0 0-.877 3.024 4.618 4.618 0 0 0 .826 2.9 4.829 4.829 0 0 0 2 1.55 21.327 21.327 0 0 0 3.075.94 22.348 22.348 0 0 1 2.364.7 3.7 3.7 0 0 1 1.41.927 2.246 2.246 0 0 1 .572 1.6 1.938 1.938 0 0 1-.991 1.83 7 7 0 0 1-4.7.28 1.771 1.771 0 0 1-1.016-.991 4.858 4.858 0 0 1-.254-2.033l-3.812.407a4.821 4.821 0 0 0 1.639 4.46 8.534 8.534 0 0 0 5.274 1.411 9.445 9.445 0 0 0 5.337-1.36 4.915 4.915 0 0 0 2.033-4.409 5.132 5.132 0 0 0-.9-3.189 5.44 5.44 0 0 0-2.159-1.732",
    transform: "translate(-277.913)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95056",
    d: "M437.761 8.7a23.385 23.385 0 0 0-3.228-1.08 21.443 21.443 0 0 1-2.173-.648 3.549 3.549 0 0 1-1.283-.8 1.786 1.786 0 0 1-.508-1.322 1.515 1.515 0 0 1 .813-1.436 4.634 4.634 0 0 1 2.211-.445 5.659 5.659 0 0 1 1.932.267 1.839 1.839 0 0 1 1.042.94 4.2 4.2 0 0 1 .3 1.893l3.736-.432a4.9 4.9 0 0 0-1.817-4.32A8.32 8.32 0 0 0 433.847 0a9.757 9.757 0 0 0-3.507.585 5.139 5.139 0 0 0-2.4 1.8 5.048 5.048 0 0 0-.877 3.024 4.619 4.619 0 0 0 .826 2.9 4.824 4.824 0 0 0 2 1.55 21.3 21.3 0 0 0 3.075.94 22.368 22.368 0 0 1 2.364.7 3.7 3.7 0 0 1 1.41.927 2.247 2.247 0 0 1 .572 1.6 1.938 1.938 0 0 1-.991 1.83 7 7 0 0 1-4.7.28 1.772 1.772 0 0 1-1.016-.991 4.853 4.853 0 0 1-.254-2.033l-3.812.407a4.821 4.821 0 0 0 1.64 4.46 8.532 8.532 0 0 0 5.273 1.411 9.446 9.446 0 0 0 5.337-1.36 4.915 4.915 0 0 0 2.033-4.409 5.133 5.133 0 0 0-.9-3.189 5.442 5.442 0 0 0-2.159-1.732",
    transform: "translate(-350.769)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95057",
    d: "M530.826 13.53a5.442 5.442 0 0 1-1.029 3.482 5.006 5.006 0 0 1-6.722 0 5.49 5.49 0 0 1-1.017-3.482V2.576H518.5V14.19a6.789 6.789 0 0 0 2.058 5.3 10.159 10.159 0 0 0 11.741 0 6.79 6.79 0 0 0 2.059-5.3V2.576h-3.533z",
    transform: "translate(-426.426 -2.119)",
    style: {
      fill: "#143d57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 95058",
    d: "m639.077 2.576-3.711 9.937-1.5 4.625h-.153l-1.448-4.625-3.787-9.937h-5.362v18.476h3.507L626.6 10.81l-.2-4.448.153-.051 1.5 4.447 3.914 10.293h3.71l3.838-10.293 1.474-4.447.153.051-.178 4.549v10.14h3.507V2.576z",
    transform: "translate(-512.465 -2.118)",
    style: {
      fill: "#143d57"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewssumLogo);
export default __webpack_public_path__ + "static/media/newssum_logo.4548a0305424f5f1761e627fdb7f99de.svg";
export { ForwardRef as ReactComponent };